import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2017367258/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
